import { SelectLang } from './00-SelectLang/SelectLang'
import { VideoHello } from './01-video-hello/VideoHello'
import { GameLabyrinth } from './02-game-labyrinth/GameLabyrinth'
import { VideoLabyrinthDone } from './03-video-labyrinth-done/VideoLabyrinthDone'
import { Map01 } from './04-map-01/Map01'
import { VideoMap } from './05-video-map/VideoMap'
import { GamePuzzle } from './06-game-puzzle/GamePuzzle'
import { Map02 } from './07-map-02/Map02'
import { Video100yearsBefore } from './08-video-100-years-before/Video100yearsBefore'
import { GameShadow } from './09-game-shadow/GameShadow'
import { Map03 } from './10-map-03/Map03'
import { VideoKlyaksus } from './11-video-klyaksus/VideoKlyaksus'
import { GameKamaz } from './12-game-kamaz/GameKamaz'
import { Map04 } from './13-map-04/Map04'
import { VideoGeographyCity } from './14-video-geography-city/VideoGeographyCity'
import { GamePaint } from './15-game-paint/GamePaint'
import { Map05 } from './16-map-05/Map05'
import { VideoStaruy } from './17-video-staruy/VideoStaruy'
import { GameDouble } from './18-game-double/GameDouble'
import { Map0607 } from './19-map-0607/Map0607'
import { VideoGeographyNature } from './20-video-geography-nature/VideoGeographyNature'
import { Map08 } from './22-map-08/Map08'
import { GameAnimals } from './21-game-animals/GameAnimals'
import { VideoWin } from './23-video-win/VideoWin'

const screens = {
    '00-SelectLang': SelectLang,

    '01-video-hello': VideoHello,
    '02-game-labyrinth': GameLabyrinth,
    '03-video-labyrinth-done': VideoLabyrinthDone,
    '04-map-01': Map01,

    '05-video-map': VideoMap,
    '06-game-puzzle': GamePuzzle,
    '07-map-02': Map02,

    '08-video-100-years-before': Video100yearsBefore,
    '09-game-shadow': GameShadow,
    '10-map-03': Map03,

    '11-video-klyaksus': VideoKlyaksus,
    '12-game-kamaz': GameKamaz,
    '13-map-04': Map04,

    '14-video-geography-city': VideoGeographyCity,
    '15-game-paint': GamePaint,
    '16-map-05': Map05,

    '17-video-staruy': VideoStaruy,
    '18-game-double': GameDouble,
    '19-map-0607': Map0607,

    '20-video-geography-nature': VideoGeographyNature,
    '21-game-animals': GameAnimals,
    '22-map-08': Map08,

    '23-video-win': VideoWin,
}

export default screens
